/* eslint-disable no-lonely-if */
/* eslint-disable array-callback-return */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
// eslint-disable-next-line simple-import-sort/imports
import withWidth from '@material-ui/core/withWidth';
import AdminCompass from '../Redesign/Compass/Admin';
import AdminCompassUserProvider from '../Redesign/Compass/AdminCompassUserProvider';

const GlobalRestitutionAdmin = () => {
  return (
    <AdminCompassUserProvider>
      <AdminCompass />
    </AdminCompassUserProvider>
  );
};

export default withWidth()(GlobalRestitutionAdmin);
